import { c as _c } from "react/compiler-runtime";
import React, { Children, isValidElement } from 'react';
import { FieldInputProps, FieldRenderProps } from 'react-final-form';
import Select, { GroupBase, PlaceholderProps, SingleValue, components } from 'react-select';
import DownIcon from '@/assets/icons/heroIcons/Down.svg';
import { mergeClasses } from '@/utils/style';
import { ErrorMessage } from '../ErrorMessage';
import { useSheet } from '@/components/Sheet/Sheet';
import SheetItem from '@/components/Sheet/SheetItem';
export const MOBILE_OPTION_HEIGHT = 48;
export const MOBILE_SHEET_HEADER_HEIGHT = 40;
export const MOBILE_SHEET_BOTTOM_PADDING = 32;
interface Option {
  label: string;
  value: string;
}
type CustomProps = {
  label: string;
  hideLabel?: boolean;
  onSelect?: (value: string | undefined) => void;
};
export function SelectInput(props) {
  const $ = _c(67);
  const hasError = props.meta.error && props.meta.touched;
  const errorId = `${props.input.name}-error`;
  let t0;
  if ($[0] !== props) {
    t0 = () => <div className="max-h-[85vh] overflow-auto">{props.options.map(t1 => {
        const {
          label,
          value
        } = t1;
        return <SheetItem onClick={() => {
          props.input.onChange(value);
          props.onSelect?.(value);
        }} key={value} isActive={value === props.input.value}>{label}</SheetItem>;
      })}</div>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.options.length * MOBILE_OPTION_HEIGHT + MOBILE_SHEET_HEADER_HEIGHT + MOBILE_SHEET_BOTTOM_PADDING;
  let t2;
  if ($[2] !== t1) {
    t2 = {
      withCloseIcon: true,
      closeOnSelect: true,
      snapPoints: [t1]
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [sheet, openSheet] = useSheet(t0, t2);
  const t3 = props.className;
  const t4 = props.label;
  const t5 = props.input.name;
  const t6 = !props.hideLabel && props.input.value !== "";
  const t7 = props.hideLabel && props.input.value !== "";
  let t8;
  if ($[4] !== t6 || $[5] !== t7) {
    t8 = mergeClasses("label", {
      "animated-label": t6,
      hidden: t7
    });
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== props.input.name || $[8] !== props.label || $[9] !== t8) {
    t9 = <label htmlFor={t5} className={t8}>{props.label}</label>;
    $[7] = props.input.name;
    $[8] = props.label;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = props.input.name;
  const t11 = props.label;
  const t12 = hasError ? errorId : undefined;
  const t13 = hasError ? "true" : "false";
  const t14 = props.input as FieldInputProps<string, HTMLElement>;
  let t15;
  if ($[11] !== props.options) {
    t15 = props.options.map(_temp);
    $[11] = props.options;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] !== props.input.name || $[14] !== props.label || $[15] !== t12 || $[16] !== t13 || $[17] !== t14 || $[18] !== t15) {
    t16 = <select id={t10} className="input pointer-events-none appearance-none pr-8 pl-3 text-ellipsis whitespace-nowrap" aria-label={t11} aria-describedby={t12} aria-invalid={t13} {...t14}>{t15}</select>;
    $[13] = props.input.name;
    $[14] = props.label;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="iconContainer absolute top-1/2 right-3 block h-6 w-6 -translate-y-1/2"><DownIcon aria-hidden="true" /></span>;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== openSheet || $[22] !== props.label || $[23] !== t16 || $[24] !== t9) {
    t18 = <button type="button" onClick={openSheet} className="relative w-full text-left" aria-haspopup="dialog" aria-label={t4}>{t9}{t16}{t17}</button>;
    $[21] = openSheet;
    $[22] = props.label;
    $[23] = t16;
    $[24] = t9;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== sheet || $[27] !== t18) {
    t19 = <div className="md:hidden">{t18}{sheet}</div>;
    $[26] = sheet;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== props) {
    t20 = value_1 => {
      props.input.onChange(value_1?.value);
      props.onSelect?.(value_1?.value);
    };
    $[29] = props;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== props.input.value || $[32] !== props.options) {
    t21 = props.options.find(option => option.value === props.input.value) || undefined;
    $[31] = props.input.value;
    $[32] = props.options;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  const t22 = hasError ? errorId : undefined;
  const t23 = hasError ? "true" : "false";
  let t24;
  if ($[34] !== props.hideLabel) {
    t24 = !props.hideLabel && {
      ValueContainer: _temp5
    };
    $[34] = props.hideLabel;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== t24) {
    t25 = {
      IndicatorSeparator: _temp2,
      DropdownIndicator: _temp3,
      ...t24
    };
    $[36] = t24;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== props.hideLabel) {
    t26 = () => mergeClasses("input border-light-gray-500 rounded-lg pr-3", {
      "justify-end!": !props.hideLabel
    });
    $[38] = props.hideLabel;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== props.meta.visited) {
    t27 = () => mergeClasses("max-w-[95%]! overflow-hidden", {
      "text-gray-600": !props.meta.visited
    });
    $[40] = props.meta.visited;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== props.hideLabel) {
    t28 = t29 => {
      const {
        isFocused,
        hasValue
      } = t29;
      return mergeClasses("label top-0 left-0 text-gray-600", {
        "animated-label px-1 -left-1": !props.hideLabel && (isFocused || hasValue)
      });
    };
    $[42] = props.hideLabel;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  let t29;
  if ($[44] !== t26 || $[45] !== t27 || $[46] !== t28) {
    t29 = {
      control: t26,
      valueContainer: _temp6,
      singleValue: t27,
      input: _temp7,
      placeholder: t28,
      menu: _temp8,
      option: _temp9
    };
    $[44] = t26;
    $[45] = t27;
    $[46] = t28;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== props.input || $[49] !== props.label || $[50] !== props.options || $[51] !== t20 || $[52] !== t21 || $[53] !== t22 || $[54] !== t23 || $[55] !== t25 || $[56] !== t29) {
    t30 = <div className="hidden md:block"><Select {...props.input} onChange={t20} unstyled={true} value={t21} options={props.options} isSearchable={false} placeholder={props.label} aria-describedby={t22} aria-invalid={t23} components={t25} classNames={t29} /></div>;
    $[48] = props.input;
    $[49] = props.label;
    $[50] = props.options;
    $[51] = t20;
    $[52] = t21;
    $[53] = t22;
    $[54] = t23;
    $[55] = t25;
    $[56] = t29;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== errorId || $[59] !== hasError || $[60] !== props.meta.error) {
    t31 = hasError && <ErrorMessage error={props.meta.error} id={errorId} />;
    $[58] = errorId;
    $[59] = hasError;
    $[60] = props.meta.error;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== props.className || $[63] !== t19 || $[64] !== t30 || $[65] !== t31) {
    t32 = <div className={t3} data-clarity-mask="true">{t19}{t30}{t31}</div>;
    $[62] = props.className;
    $[63] = t19;
    $[64] = t30;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  return t32;
}
function _temp9(t0) {
  const {
    isFocused: isFocused_0,
    isSelected
  } = t0;
  return mergeClasses("py-3 px-4 cursor-pointer!", {
    "bg-gray-50 font-semibold text-gray-900": isSelected
  }, {
    "bg-blue-50": isFocused_0
  });
}
function _temp8() {
  return "rounded-lg bg-white mt-2 border border-gray-100 z-50! shadow-none [&>div]:py-0 [&>div]:rounded-lg";
}
function _temp7() {
  return "p-0 m-0 text-gray-900";
}
function _temp6() {
  return "p-0! flex! overflow-visible! w-[calc(100%-1.5rem)]";
}
function _temp5(t0) {
  const {
    children,
    ...valueContainerProps
  } = t0;
  if (valueContainerProps.innerProps) {
    const placeholderProps = {
      ...valueContainerProps,
      children: valueContainerProps.selectProps.placeholder,
      innerProps: valueContainerProps.innerProps,
      isFocused: valueContainerProps.selectProps.menuIsOpen
    };
    return <components.ValueContainer {...valueContainerProps}><components.Placeholder {...placeholderProps}>{valueContainerProps.selectProps.placeholder}</components.Placeholder>{Children.map(children, _temp4)}</components.ValueContainer>;
  }
}
function _temp4(child) {
  return isValidElement(child) && child.type !== components.Placeholder ? child : null;
}
function _temp3(dropdownProps) {
  return <components.DropdownIndicator {...dropdownProps} className="p-0!"><span className={mergeClasses("transition-transform", dropdownProps.selectProps.menuIsOpen ? "rotate-180" : "rotate-0")}><DownIcon /></span></components.DropdownIndicator>;
}
function _temp2() {
  return null;
}
function _temp(t0) {
  const {
    label: label_0,
    value: value_0
  } = t0;
  return <option key={value_0} value={value_0}>{label_0}</option>;
}